module.exports = "/_next/static/images/TrrystDataSuiteLandingPageFeaturesBackground-4c47e9a9bd518c82912499ebdf182f64.svg";